(function($){

	
	var photoGallery = function(){

		var inlineGalleryContainer = $('.inline-gallery');
		var inlineGalleryAnchor = $('#inline-gallery-anchor');

		var mainImgContainer = $('#inline-gallery-main-img-container');
		var mainImgLink = $('#inline-gallery-main-img-link');
		var mainImg = document.getElementById('inline-gallery-main-img');
		var mainImgObj = $('#inline-gallery-main-img');
		var mainImgContainerHeight;
		var galleryTotal = parseInt(mainImgContainer.attr('data-total-imgs'));

		var setMainImgHeight = function(){
			//mainImgContainerHeight = $('.main-img').width() * mainImgContainer.attr('data-init-ratio');
			mainImgContainer.height(mainImgContainer.width() * mainImgContainer.attr('data-init-ratio'));
		};

		setMainImgHeight();
		optimizedResize.add( setMainImgHeight );
		
		$('#inline-gallery-list').on('click', '.gallery-img', function(e){
			e.preventDefault();
			var newRatio = $(this).attr('data-ratio');
			var newHeight = mainImgContainer.width() * newRatio;
			var newUrl = $(this).attr('data-target');
			var newHref = this.href;

			// console.log(newHref);

			mainImgContainer.attr('data-init-ratio', newRatio);
			mainImgObj.css('opacity', 0);

			var newSrcWidth = $(this).attr('data-width');
			var newSrcHeight = $(this).attr('data-height');
			var newSrcUrl = $(this).attr('data-zoom-url');
			var imgNumber = $(this).attr('data-img');

			mainImgContainer.attr('data-width', newSrcWidth);
			mainImgContainer.attr('data-height', newSrcHeight);
			mainImgLink.attr('href', newHref);
			mainImgContainer.attr('data-current-img', imgNumber);
			

			$(this).addClass('active');
			$('.inline-gallery-list .gallery-img').not(this).removeClass('active');

			
			// scroll to top of gallery
			var waitTime = 0;
			
			setTimeout(function(){
				mainImg.src = newUrl;
				mainImgContainer.css('height', newHeight);
				
				setTimeout(function(){
					mainImgObj.css('opacity', 1);
				}, 300);
			}, 300);

		});

		$('.inline-gallery').magnificPopup({
			type: 'image',
			delegate: 'a.popup-img',
			gallery: {
				enabled: true
			}
		});

	};

	// var photoGalleryPopup = function(){
	// 	$('.popup-gallery').magnificPopup({
	// 		type: 'image',
	// 		delegate: 'a',
	// 		gallery: {
	// 			enabled: true
	// 		}
	// 	});
	// };

	$(document).ready(function(){
		photoGallery();
	});

})(jQuery);